import styled from 'styled-components'
import L from '../L'

const StyledMenuIcon = styled(L).attrs({
  display: 'grid',
  ai: 'center',
  position: 'relative',
  selectable: true,
})`
  transition: ${props => props.theme.mixins.transition(['color'])};

  &:after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    right: 0;
    margin-left: calc(-50% - 3px);
    margin-right: auto;
    width: 55px;
    height: 3px;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    background-color: ${props => props.theme.palette.primary.main};
    transition: ${props => props.theme.mixins.transition(['opacity', 'visibility'])};
  }

  ${props =>
    props.active
      ? `
      color: ${props => props.theme.palette.primary.main};
  
      &:after {
        opacity: 1;
        visibility: visible;
      }
    `
      : ``}
`

export default StyledMenuIcon
